module.exports = __webpack_public_path__ + "static/media/M53ws.a43a5465.pdf";